import { useState, useEffect } from "react";
import * as Yup from "yup";
import { useForm, SubmitHandler, Resolver } from "react-hook-form";
import {
  SignIn as USER_SIGNIN,
} from "src/components/api/user/user";
import { ToastError } from "src/components/uiElements/toast";
import { LOGOUT } from "src/components/helper/constants";
import { yupResolver } from "@hookform/resolvers/yup";
import { isBrowser } from "src/components/api/helper/apiHelper";
import { useDispatch, useSelector } from "react-redux";
import { login, logout as reduxLogout, selectAuth } from "src/store/authSlice";
import { speakText } from "src/components/helper/textToSpeech";

type LoginProps = {
  UserName: string;
  Password: string;
  FingerPrint: string;
  CaptchaToken: string | undefined | null;
  Device: string;
  Latitude: number | undefined;
  Longitude: number | undefined;
};

const useSignIn = () => {
  const dispatch = useDispatch();
  const auth = useSelector(selectAuth);

  const validationSchema = Yup.object().shape({
    UserName: Yup.string().required("Phone number is required"),
    Password: Yup.string().required("Password is required"),
  });

  const defaultValues = {
    Device: "web",
    UserName: "",
    Password: "",
  };

  const [loading, setLoading] = useState(false);
  const [IsTwoFAOpen, setIsTwoFAOpen] = useState(false);
  const [modalErrorMessage, setModalErrorMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [isPasswordResetSuccessOpen, setIsPasswordResetSuccessOpen] = useState(false);
  const formContext = useForm<LoginProps>({
    defaultValues,
    resolver: yupResolver(validationSchema) as any,
  });

  
  const handleButtonClick = (UserName : string ,Password : string) => {
    if (rememberMe === true) {
      window.localStorage.setItem("RememberMe", "1");
      window.localStorage.setItem("UserName", UserName);
      window.localStorage.setItem("Password", Password);
    } else {
      window.localStorage.removeItem("RememberMe");
      window.localStorage.removeItem("UserName");
      window.localStorage.removeItem("Password");
    }
  };
  const onSubmit: SubmitHandler<LoginProps> = async (values) => {
    setModalErrorMessage("");
    setIsError(false);
    handleButtonClick(values.UserName,values.Password)
    setLoading(false);
    let response = await USER_SIGNIN(JSON.stringify(values));
    console.log("response", response)
    setLoading(false);

    if (!response?.isAuthorized) {
      dispatch(reduxLogout());
      LOGOUT();
    }

    if (!response?.status) {
      let failResult = JSON.parse(response?.data!);
      ToastError(failResult.Message);
      return;
    }

    let result = JSON.parse(response?.data!);
console.log("result.Department:", result.Department)
    setIsTwoFAOpen(false);
    parseLoginresponse(result);
setIsPasswordResetSuccessOpen(false);
  };

  const parseLoginresponse = async (result: any) => {

      let userInfo = {
        jwtToken: result.Token,
        UserID: result.UserID,
        UserTypeID: result.UserTypeID,
        PersonName: result.PersonName,
        EmployeeID:result.EmployeeID,
        Designation:result.Designation,
        Department:result.Department,
        UserRole: result.UserType,
        FirmName: result.FirmName,
        ProfileImagePath: result.ProfileImagePath,
      };

      dispatch(login(userInfo));
      sessionStorage.setItem("UserID", result.UserID);
      sessionStorage.setItem("EmployeeID", result.EmployeeID);
      sessionStorage.setItem("Designation", result.Designation);
      sessionStorage.setItem("Department", result.Department);
      sessionStorage.setItem("Token", result.Token);
      sessionStorage.setItem("UserTypeID", result.UserTypeID);
      sessionStorage.setItem("MenuList", JSON.stringify(result.MenuList));
      if (result.PersonName) {
        speakText(`Welcome ${result.PersonName}`);
      } else {
        console.warn('PersonName is not available in the result');
        speakText("Welcome User");
      }

      // if (isBrowser()) {
      //   window.location.href =  result.RedirectTo;
      // } 

         // Wait a moment for the voice to speak before redirecting
      setTimeout(() => {
        if (isBrowser()) {
          window.location.href = result.RedirectTo;
        }
      }, 2000); // Wait 2 seconds for the voice to complete
  };

  return {
    loading,
    rememberMe,
    defaultValues,
    validationSchema,
    formContext,
    IsTwoFAOpen,
    isError,
    modalErrorMessage,
    setIsTwoFAOpen,
    setRememberMe,
    onSubmit,
    isPasswordResetSuccessOpen, setIsPasswordResetSuccessOpen,
  };
};

export default useSignIn;
